var cov_2gmp3atjkq = function () {
  var path = "/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/authMFA/mfaController.js",
      hash = "fa87b2495104f9c1ff633caf43cb999410b9cc32",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/authMFA/mfaController.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 411,
          column: 4
        }
      },
      "1": {
        start: {
          line: 19,
          column: 19
        },
        end: {
          line: 19,
          column: 27
        }
      },
      "2": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 21,
          column: 32
        }
      },
      "3": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 34
        }
      },
      "4": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 34
        }
      },
      "5": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 38
        }
      },
      "6": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 39
        }
      },
      "7": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 35
        }
      },
      "8": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 35
        }
      },
      "9": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 32,
          column: 32
        }
      },
      "10": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 33,
          column: 31
        }
      },
      "11": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 22
        }
      },
      "12": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 28
        }
      },
      "13": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 40
        }
      },
      "14": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 42,
          column: 8
        }
      },
      "15": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 47
        }
      },
      "16": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 55,
          column: 9
        }
      },
      "17": {
        start: {
          line: 51,
          column: 10
        },
        end: {
          line: 51,
          column: 36
        }
      },
      "18": {
        start: {
          line: 53,
          column: 10
        },
        end: {
          line: 53,
          column: 58
        }
      },
      "19": {
        start: {
          line: 54,
          column: 10
        },
        end: {
          line: 54,
          column: 56
        }
      },
      "20": {
        start: {
          line: 61,
          column: 6
        },
        end: {
          line: 68,
          column: 8
        }
      },
      "21": {
        start: {
          line: 62,
          column: 8
        },
        end: {
          line: 62,
          column: 36
        }
      },
      "22": {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 63,
          column: 36
        }
      },
      "23": {
        start: {
          line: 64,
          column: 8
        },
        end: {
          line: 64,
          column: 40
        }
      },
      "24": {
        start: {
          line: 65,
          column: 8
        },
        end: {
          line: 65,
          column: 41
        }
      },
      "25": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 37
        }
      },
      "26": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 42
        }
      },
      "27": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 110,
          column: 8
        }
      },
      "28": {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 76,
          column: 36
        }
      },
      "29": {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 109,
          column: 11
        }
      },
      "30": {
        start: {
          line: 78,
          column: 10
        },
        end: {
          line: 78,
          column: 46
        }
      },
      "31": {
        start: {
          line: 79,
          column: 10
        },
        end: {
          line: 79,
          column: 35
        }
      },
      "32": {
        start: {
          line: 80,
          column: 10
        },
        end: {
          line: 80,
          column: 38
        }
      },
      "33": {
        start: {
          line: 81,
          column: 10
        },
        end: {
          line: 81,
          column: 56
        }
      },
      "34": {
        start: {
          line: 82,
          column: 10
        },
        end: {
          line: 82,
          column: 25
        }
      },
      "35": {
        start: {
          line: 86,
          column: 10
        },
        end: {
          line: 106,
          column: 11
        }
      },
      "36": {
        start: {
          line: 88,
          column: 12
        },
        end: {
          line: 91,
          column: 13
        }
      },
      "37": {
        start: {
          line: 89,
          column: 12
        },
        end: {
          line: 89,
          column: 41
        }
      },
      "38": {
        start: {
          line: 90,
          column: 12
        },
        end: {
          line: 90,
          column: 19
        }
      },
      "39": {
        start: {
          line: 93,
          column: 12
        },
        end: {
          line: 93,
          column: 39
        }
      },
      "40": {
        start: {
          line: 94,
          column: 12
        },
        end: {
          line: 100,
          column: 13
        }
      },
      "41": {
        start: {
          line: 99,
          column: 14
        },
        end: {
          line: 99,
          column: 54
        }
      },
      "42": {
        start: {
          line: 102,
          column: 12
        },
        end: {
          line: 105,
          column: 13
        }
      },
      "43": {
        start: {
          line: 103,
          column: 14
        },
        end: {
          line: 103,
          column: 54
        }
      },
      "44": {
        start: {
          line: 104,
          column: 14
        },
        end: {
          line: 104,
          column: 36
        }
      },
      "45": {
        start: {
          line: 108,
          column: 10
        },
        end: {
          line: 108,
          column: 36
        }
      },
      "46": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 123,
          column: 8
        }
      },
      "47": {
        start: {
          line: 118,
          column: 8
        },
        end: {
          line: 120,
          column: 9
        }
      },
      "48": {
        start: {
          line: 119,
          column: 10
        },
        end: {
          line: 119,
          column: 22
        }
      },
      "49": {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 122,
          column: 21
        }
      },
      "50": {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 149,
          column: 8
        }
      },
      "51": {
        start: {
          line: 135,
          column: 8
        },
        end: {
          line: 135,
          column: 41
        }
      },
      "52": {
        start: {
          line: 138,
          column: 8
        },
        end: {
          line: 138,
          column: 37
        }
      },
      "53": {
        start: {
          line: 139,
          column: 8
        },
        end: {
          line: 139,
          column: 40
        }
      },
      "54": {
        start: {
          line: 140,
          column: 8
        },
        end: {
          line: 140,
          column: 41
        }
      },
      "55": {
        start: {
          line: 141,
          column: 8
        },
        end: {
          line: 141,
          column: 37
        }
      },
      "56": {
        start: {
          line: 142,
          column: 8
        },
        end: {
          line: 142,
          column: 33
        }
      },
      "57": {
        start: {
          line: 143,
          column: 8
        },
        end: {
          line: 143,
          column: 40
        }
      },
      "58": {
        start: {
          line: 144,
          column: 8
        },
        end: {
          line: 144,
          column: 29
        }
      },
      "59": {
        start: {
          line: 146,
          column: 8
        },
        end: {
          line: 148,
          column: 11
        }
      },
      "60": {
        start: {
          line: 160,
          column: 6
        },
        end: {
          line: 204,
          column: 8
        }
      },
      "61": {
        start: {
          line: 161,
          column: 8
        },
        end: {
          line: 161,
          column: 49
        }
      },
      "62": {
        start: {
          line: 163,
          column: 56
        },
        end: {
          line: 163,
          column: 62
        }
      },
      "63": {
        start: {
          line: 164,
          column: 8
        },
        end: {
          line: 169,
          column: 9
        }
      },
      "64": {
        start: {
          line: 165,
          column: 10
        },
        end: {
          line: 167,
          column: 12
        }
      },
      "65": {
        start: {
          line: 168,
          column: 10
        },
        end: {
          line: 168,
          column: 17
        }
      },
      "66": {
        start: {
          line: 171,
          column: 46
        },
        end: {
          line: 171,
          column: 55
        }
      },
      "67": {
        start: {
          line: 172,
          column: 8
        },
        end: {
          line: 177,
          column: 9
        }
      },
      "68": {
        start: {
          line: 173,
          column: 10
        },
        end: {
          line: 175,
          column: 12
        }
      },
      "69": {
        start: {
          line: 176,
          column: 10
        },
        end: {
          line: 176,
          column: 17
        }
      },
      "70": {
        start: {
          line: 179,
          column: 8
        },
        end: {
          line: 203,
          column: 10
        }
      },
      "71": {
        start: {
          line: 191,
          column: 12
        },
        end: {
          line: 191,
          column: 46
        }
      },
      "72": {
        start: {
          line: 193,
          column: 12
        },
        end: {
          line: 195,
          column: 13
        }
      },
      "73": {
        start: {
          line: 194,
          column: 14
        },
        end: {
          line: 194,
          column: 35
        }
      },
      "74": {
        start: {
          line: 198,
          column: 12
        },
        end: {
          line: 198,
          column: 76
        }
      },
      "75": {
        start: {
          line: 199,
          column: 12
        },
        end: {
          line: 201,
          column: 14
        }
      },
      "76": {
        start: {
          line: 213,
          column: 6
        },
        end: {
          line: 220,
          column: 8
        }
      },
      "77": {
        start: {
          line: 214,
          column: 8
        },
        end: {
          line: 214,
          column: 33
        }
      },
      "78": {
        start: {
          line: 215,
          column: 8
        },
        end: {
          line: 219,
          column: 11
        }
      },
      "79": {
        start: {
          line: 216,
          column: 10
        },
        end: {
          line: 216,
          column: 52
        }
      },
      "80": {
        start: {
          line: 218,
          column: 10
        },
        end: {
          line: 218,
          column: 36
        }
      },
      "81": {
        start: {
          line: 230,
          column: 6
        },
        end: {
          line: 236,
          column: 8
        }
      },
      "82": {
        start: {
          line: 231,
          column: 8
        },
        end: {
          line: 231,
          column: 33
        }
      },
      "83": {
        start: {
          line: 232,
          column: 8
        },
        end: {
          line: 235,
          column: 11
        }
      },
      "84": {
        start: {
          line: 233,
          column: 10
        },
        end: {
          line: 233,
          column: 36
        }
      },
      "85": {
        start: {
          line: 234,
          column: 10
        },
        end: {
          line: 234,
          column: 25
        }
      },
      "86": {
        start: {
          line: 253,
          column: 6
        },
        end: {
          line: 304,
          column: 8
        }
      },
      "87": {
        start: {
          line: 254,
          column: 8
        },
        end: {
          line: 254,
          column: 33
        }
      },
      "88": {
        start: {
          line: 255,
          column: 8
        },
        end: {
          line: 255,
          column: 51
        }
      },
      "89": {
        start: {
          line: 256,
          column: 8
        },
        end: {
          line: 260,
          column: 9
        }
      },
      "90": {
        start: {
          line: 257,
          column: 10
        },
        end: {
          line: 257,
          column: 35
        }
      },
      "91": {
        start: {
          line: 258,
          column: 10
        },
        end: {
          line: 258,
          column: 41
        }
      },
      "92": {
        start: {
          line: 259,
          column: 10
        },
        end: {
          line: 259,
          column: 17
        }
      },
      "93": {
        start: {
          line: 262,
          column: 8
        },
        end: {
          line: 283,
          column: 9
        }
      },
      "94": {
        start: {
          line: 263,
          column: 10
        },
        end: {
          line: 281,
          column: 12
        }
      },
      "95": {
        start: {
          line: 267,
          column: 14
        },
        end: {
          line: 267,
          column: 59
        }
      },
      "96": {
        start: {
          line: 268,
          column: 14
        },
        end: {
          line: 268,
          column: 52
        }
      },
      "97": {
        start: {
          line: 270,
          column: 14
        },
        end: {
          line: 270,
          column: 46
        }
      },
      "98": {
        start: {
          line: 271,
          column: 14
        },
        end: {
          line: 278,
          column: 15
        }
      },
      "99": {
        start: {
          line: 272,
          column: 16
        },
        end: {
          line: 272,
          column: 41
        }
      },
      "100": {
        start: {
          line: 273,
          column: 16
        },
        end: {
          line: 273,
          column: 37
        }
      },
      "101": {
        start: {
          line: 274,
          column: 16
        },
        end: {
          line: 274,
          column: 45
        }
      },
      "102": {
        start: {
          line: 276,
          column: 16
        },
        end: {
          line: 276,
          column: 40
        }
      },
      "103": {
        start: {
          line: 277,
          column: 16
        },
        end: {
          line: 277,
          column: 23
        }
      },
      "104": {
        start: {
          line: 279,
          column: 14
        },
        end: {
          line: 279,
          column: 40
        }
      },
      "105": {
        start: {
          line: 282,
          column: 10
        },
        end: {
          line: 282,
          column: 17
        }
      },
      "106": {
        start: {
          line: 285,
          column: 8
        },
        end: {
          line: 303,
          column: 10
        }
      },
      "107": {
        start: {
          line: 289,
          column: 12
        },
        end: {
          line: 289,
          column: 57
        }
      },
      "108": {
        start: {
          line: 290,
          column: 12
        },
        end: {
          line: 290,
          column: 50
        }
      },
      "109": {
        start: {
          line: 292,
          column: 12
        },
        end: {
          line: 292,
          column: 44
        }
      },
      "110": {
        start: {
          line: 293,
          column: 12
        },
        end: {
          line: 300,
          column: 13
        }
      },
      "111": {
        start: {
          line: 294,
          column: 14
        },
        end: {
          line: 294,
          column: 39
        }
      },
      "112": {
        start: {
          line: 295,
          column: 14
        },
        end: {
          line: 295,
          column: 35
        }
      },
      "113": {
        start: {
          line: 296,
          column: 14
        },
        end: {
          line: 296,
          column: 43
        }
      },
      "114": {
        start: {
          line: 298,
          column: 14
        },
        end: {
          line: 298,
          column: 38
        }
      },
      "115": {
        start: {
          line: 299,
          column: 14
        },
        end: {
          line: 299,
          column: 21
        }
      },
      "116": {
        start: {
          line: 301,
          column: 12
        },
        end: {
          line: 301,
          column: 38
        }
      },
      "117": {
        start: {
          line: 321,
          column: 6
        },
        end: {
          line: 345,
          column: 8
        }
      },
      "118": {
        start: {
          line: 322,
          column: 8
        },
        end: {
          line: 322,
          column: 33
        }
      },
      "119": {
        start: {
          line: 323,
          column: 8
        },
        end: {
          line: 323,
          column: 43
        }
      },
      "120": {
        start: {
          line: 324,
          column: 8
        },
        end: {
          line: 328,
          column: 9
        }
      },
      "121": {
        start: {
          line: 325,
          column: 10
        },
        end: {
          line: 325,
          column: 35
        }
      },
      "122": {
        start: {
          line: 326,
          column: 10
        },
        end: {
          line: 326,
          column: 41
        }
      },
      "123": {
        start: {
          line: 327,
          column: 10
        },
        end: {
          line: 327,
          column: 17
        }
      },
      "124": {
        start: {
          line: 330,
          column: 8
        },
        end: {
          line: 344,
          column: 10
        }
      },
      "125": {
        start: {
          line: 334,
          column: 12
        },
        end: {
          line: 334,
          column: 49
        }
      },
      "126": {
        start: {
          line: 335,
          column: 12
        },
        end: {
          line: 335,
          column: 44
        }
      },
      "127": {
        start: {
          line: 336,
          column: 12
        },
        end: {
          line: 341,
          column: 13
        }
      },
      "128": {
        start: {
          line: 337,
          column: 14
        },
        end: {
          line: 337,
          column: 43
        }
      },
      "129": {
        start: {
          line: 339,
          column: 14
        },
        end: {
          line: 339,
          column: 38
        }
      },
      "130": {
        start: {
          line: 340,
          column: 14
        },
        end: {
          line: 340,
          column: 21
        }
      },
      "131": {
        start: {
          line: 342,
          column: 12
        },
        end: {
          line: 342,
          column: 38
        }
      },
      "132": {
        start: {
          line: 350,
          column: 6
        },
        end: {
          line: 352,
          column: 8
        }
      },
      "133": {
        start: {
          line: 351,
          column: 8
        },
        end: {
          line: 351,
          column: 37
        }
      },
      "134": {
        start: {
          line: 362,
          column: 6
        },
        end: {
          line: 367,
          column: 8
        }
      },
      "135": {
        start: {
          line: 363,
          column: 8
        },
        end: {
          line: 363,
          column: 33
        }
      },
      "136": {
        start: {
          line: 364,
          column: 8
        },
        end: {
          line: 364,
          column: 33
        }
      },
      "137": {
        start: {
          line: 365,
          column: 8
        },
        end: {
          line: 365,
          column: 36
        }
      },
      "138": {
        start: {
          line: 366,
          column: 8
        },
        end: {
          line: 366,
          column: 37
        }
      },
      "139": {
        start: {
          line: 376,
          column: 6
        },
        end: {
          line: 379,
          column: 8
        }
      },
      "140": {
        start: {
          line: 377,
          column: 8
        },
        end: {
          line: 377,
          column: 53
        }
      },
      "141": {
        start: {
          line: 378,
          column: 8
        },
        end: {
          line: 378,
          column: 32
        }
      },
      "142": {
        start: {
          line: 389,
          column: 25
        },
        end: {
          line: 399,
          column: 7
        }
      },
      "143": {
        start: {
          line: 390,
          column: 8
        },
        end: {
          line: 390,
          column: 42
        }
      },
      "144": {
        start: {
          line: 390,
          column: 35
        },
        end: {
          line: 390,
          column: 42
        }
      },
      "145": {
        start: {
          line: 391,
          column: 28
        },
        end: {
          line: 393,
          column: 9
        }
      },
      "146": {
        start: {
          line: 394,
          column: 8
        },
        end: {
          line: 398,
          column: 9
        }
      },
      "147": {
        start: {
          line: 395,
          column: 10
        },
        end: {
          line: 397,
          column: 13
        }
      },
      "148": {
        start: {
          line: 396,
          column: 12
        },
        end: {
          line: 396,
          column: 41
        }
      },
      "149": {
        start: {
          line: 401,
          column: 6
        },
        end: {
          line: 401,
          column: 42
        }
      },
      "150": {
        start: {
          line: 404,
          column: 6
        },
        end: {
          line: 406,
          column: 9
        }
      },
      "151": {
        start: {
          line: 405,
          column: 8
        },
        end: {
          line: 405,
          column: 45
        }
      },
      "152": {
        start: {
          line: 409,
          column: 6
        },
        end: {
          line: 409,
          column: 13
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 4
          },
          end: {
            line: 5,
            column: 5
          }
        },
        loc: {
          start: {
            line: 18,
            column: 9
          },
          end: {
            line: 410,
            column: 5
          }
        },
        line: 18
      },
      "1": {
        name: "init",
        decl: {
          start: {
            line: 49,
            column: 15
          },
          end: {
            line: 49,
            column: 19
          }
        },
        loc: {
          start: {
            line: 49,
            column: 22
          },
          end: {
            line: 56,
            column: 7
          }
        },
        line: 49
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 61,
            column: 22
          },
          end: {
            line: 61,
            column: 23
          }
        },
        loc: {
          start: {
            line: 61,
            column: 34
          },
          end: {
            line: 68,
            column: 7
          }
        },
        line: 61
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 75,
            column: 32
          },
          end: {
            line: 75,
            column: 33
          }
        },
        loc: {
          start: {
            line: 75,
            column: 44
          },
          end: {
            line: 110,
            column: 7
          }
        },
        line: 75
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 77,
            column: 61
          },
          end: {
            line: 77,
            column: 62
          }
        },
        loc: {
          start: {
            line: 77,
            column: 71
          },
          end: {
            line: 109,
            column: 9
          }
        },
        line: 77
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 117,
            column: 33
          },
          end: {
            line: 117,
            column: 34
          }
        },
        loc: {
          start: {
            line: 117,
            column: 45
          },
          end: {
            line: 123,
            column: 7
          }
        },
        line: 117
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 134,
            column: 38
          },
          end: {
            line: 134,
            column: 39
          }
        },
        loc: {
          start: {
            line: 134,
            column: 50
          },
          end: {
            line: 149,
            column: 7
          }
        },
        line: 134
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 160,
            column: 30
          },
          end: {
            line: 160,
            column: 31
          }
        },
        loc: {
          start: {
            line: 160,
            column: 42
          },
          end: {
            line: 204,
            column: 7
          }
        },
        line: 160
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 190,
            column: 10
          },
          end: {
            line: 190,
            column: 11
          }
        },
        loc: {
          start: {
            line: 190,
            column: 24
          },
          end: {
            line: 196,
            column: 11
          }
        },
        line: 190
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 197,
            column: 10
          },
          end: {
            line: 197,
            column: 11
          }
        },
        loc: {
          start: {
            line: 197,
            column: 21
          },
          end: {
            line: 202,
            column: 11
          }
        },
        line: 197
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 213,
            column: 25
          },
          end: {
            line: 213,
            column: 26
          }
        },
        loc: {
          start: {
            line: 213,
            column: 37
          },
          end: {
            line: 220,
            column: 7
          }
        },
        line: 213
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 215,
            column: 54
          },
          end: {
            line: 215,
            column: 55
          }
        },
        loc: {
          start: {
            line: 215,
            column: 64
          },
          end: {
            line: 219,
            column: 9
          }
        },
        line: 215
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 230,
            column: 28
          },
          end: {
            line: 230,
            column: 29
          }
        },
        loc: {
          start: {
            line: 230,
            column: 40
          },
          end: {
            line: 236,
            column: 7
          }
        },
        line: 230
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 232,
            column: 56
          },
          end: {
            line: 232,
            column: 57
          }
        },
        loc: {
          start: {
            line: 232,
            column: 66
          },
          end: {
            line: 235,
            column: 9
          }
        },
        line: 232
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 253,
            column: 30
          },
          end: {
            line: 253,
            column: 31
          }
        },
        loc: {
          start: {
            line: 253,
            column: 42
          },
          end: {
            line: 304,
            column: 7
          }
        },
        line: 253
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 266,
            column: 12
          },
          end: {
            line: 266,
            column: 13
          }
        },
        loc: {
          start: {
            line: 266,
            column: 26
          },
          end: {
            line: 280,
            column: 13
          }
        },
        line: 266
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 288,
            column: 10
          },
          end: {
            line: 288,
            column: 11
          }
        },
        loc: {
          start: {
            line: 288,
            column: 24
          },
          end: {
            line: 302,
            column: 11
          }
        },
        line: 288
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 321,
            column: 24
          },
          end: {
            line: 321,
            column: 25
          }
        },
        loc: {
          start: {
            line: 321,
            column: 36
          },
          end: {
            line: 345,
            column: 7
          }
        },
        line: 321
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 333,
            column: 10
          },
          end: {
            line: 333,
            column: 11
          }
        },
        loc: {
          start: {
            line: 333,
            column: 24
          },
          end: {
            line: 343,
            column: 11
          }
        },
        line: 333
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 350,
            column: 27
          },
          end: {
            line: 350,
            column: 28
          }
        },
        loc: {
          start: {
            line: 350,
            column: 39
          },
          end: {
            line: 352,
            column: 7
          }
        },
        line: 350
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 362,
            column: 22
          },
          end: {
            line: 362,
            column: 23
          }
        },
        loc: {
          start: {
            line: 362,
            column: 44
          },
          end: {
            line: 367,
            column: 7
          }
        },
        line: 362
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 376,
            column: 26
          },
          end: {
            line: 376,
            column: 27
          }
        },
        loc: {
          start: {
            line: 376,
            column: 43
          },
          end: {
            line: 379,
            column: 7
          }
        },
        line: 376
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 389,
            column: 25
          },
          end: {
            line: 389,
            column: 26
          }
        },
        loc: {
          start: {
            line: 389,
            column: 42
          },
          end: {
            line: 399,
            column: 7
          }
        },
        line: 389
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 395,
            column: 24
          },
          end: {
            line: 395,
            column: 25
          }
        },
        loc: {
          start: {
            line: 395,
            column: 36
          },
          end: {
            line: 397,
            column: 11
          }
        },
        line: 395
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 404,
            column: 29
          },
          end: {
            line: 404,
            column: 30
          }
        },
        loc: {
          start: {
            line: 404,
            column: 41
          },
          end: {
            line: 406,
            column: 7
          }
        },
        line: 404
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        }, {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        }],
        line: 50
      },
      "1": {
        loc: {
          start: {
            line: 86,
            column: 10
          },
          end: {
            line: 106,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 10
          },
          end: {
            line: 106,
            column: 11
          }
        }, {
          start: {
            line: 86,
            column: 10
          },
          end: {
            line: 106,
            column: 11
          }
        }],
        line: 86
      },
      "2": {
        loc: {
          start: {
            line: 88,
            column: 12
          },
          end: {
            line: 91,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 12
          },
          end: {
            line: 91,
            column: 13
          }
        }, {
          start: {
            line: 88,
            column: 12
          },
          end: {
            line: 91,
            column: 13
          }
        }],
        line: 88
      },
      "3": {
        loc: {
          start: {
            line: 94,
            column: 12
          },
          end: {
            line: 100,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 12
          },
          end: {
            line: 100,
            column: 13
          }
        }, {
          start: {
            line: 94,
            column: 12
          },
          end: {
            line: 100,
            column: 13
          }
        }],
        line: 94
      },
      "4": {
        loc: {
          start: {
            line: 95,
            column: 14
          },
          end: {
            line: 97,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 95,
            column: 14
          },
          end: {
            line: 95,
            column: 49
          }
        }, {
          start: {
            line: 96,
            column: 14
          },
          end: {
            line: 96,
            column: 55
          }
        }, {
          start: {
            line: 97,
            column: 14
          },
          end: {
            line: 97,
            column: 57
          }
        }],
        line: 95
      },
      "5": {
        loc: {
          start: {
            line: 102,
            column: 12
          },
          end: {
            line: 105,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 12
          },
          end: {
            line: 105,
            column: 13
          }
        }, {
          start: {
            line: 102,
            column: 12
          },
          end: {
            line: 105,
            column: 13
          }
        }],
        line: 102
      },
      "6": {
        loc: {
          start: {
            line: 118,
            column: 8
          },
          end: {
            line: 120,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 118,
            column: 8
          },
          end: {
            line: 120,
            column: 9
          }
        }, {
          start: {
            line: 118,
            column: 8
          },
          end: {
            line: 120,
            column: 9
          }
        }],
        line: 118
      },
      "7": {
        loc: {
          start: {
            line: 118,
            column: 12
          },
          end: {
            line: 118,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 118,
            column: 12
          },
          end: {
            line: 118,
            column: 32
          }
        }, {
          start: {
            line: 118,
            column: 36
          },
          end: {
            line: 118,
            column: 89
          }
        }],
        line: 118
      },
      "8": {
        loc: {
          start: {
            line: 164,
            column: 8
          },
          end: {
            line: 169,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 164,
            column: 8
          },
          end: {
            line: 169,
            column: 9
          }
        }, {
          start: {
            line: 164,
            column: 8
          },
          end: {
            line: 169,
            column: 9
          }
        }],
        line: 164
      },
      "9": {
        loc: {
          start: {
            line: 164,
            column: 12
          },
          end: {
            line: 164,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 164,
            column: 12
          },
          end: {
            line: 164,
            column: 26
          }
        }, {
          start: {
            line: 164,
            column: 30
          },
          end: {
            line: 164,
            column: 40
          }
        }, {
          start: {
            line: 164,
            column: 44
          },
          end: {
            line: 164,
            column: 54
          }
        }],
        line: 164
      },
      "10": {
        loc: {
          start: {
            line: 172,
            column: 8
          },
          end: {
            line: 177,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 172,
            column: 8
          },
          end: {
            line: 177,
            column: 9
          }
        }, {
          start: {
            line: 172,
            column: 8
          },
          end: {
            line: 177,
            column: 9
          }
        }],
        line: 172
      },
      "11": {
        loc: {
          start: {
            line: 193,
            column: 12
          },
          end: {
            line: 195,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 193,
            column: 12
          },
          end: {
            line: 195,
            column: 13
          }
        }, {
          start: {
            line: 193,
            column: 12
          },
          end: {
            line: 195,
            column: 13
          }
        }],
        line: 193
      },
      "12": {
        loc: {
          start: {
            line: 256,
            column: 8
          },
          end: {
            line: 260,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 256,
            column: 8
          },
          end: {
            line: 260,
            column: 9
          }
        }, {
          start: {
            line: 256,
            column: 8
          },
          end: {
            line: 260,
            column: 9
          }
        }],
        line: 256
      },
      "13": {
        loc: {
          start: {
            line: 256,
            column: 12
          },
          end: {
            line: 256,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 256,
            column: 12
          },
          end: {
            line: 256,
            column: 28
          }
        }, {
          start: {
            line: 256,
            column: 32
          },
          end: {
            line: 256,
            column: 58
          }
        }],
        line: 256
      },
      "14": {
        loc: {
          start: {
            line: 262,
            column: 8
          },
          end: {
            line: 283,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 262,
            column: 8
          },
          end: {
            line: 283,
            column: 9
          }
        }, {
          start: {
            line: 262,
            column: 8
          },
          end: {
            line: 283,
            column: 9
          }
        }],
        line: 262
      },
      "15": {
        loc: {
          start: {
            line: 262,
            column: 11
          },
          end: {
            line: 262,
            column: 99
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 262,
            column: 11
          },
          end: {
            line: 262,
            column: 52
          }
        }, {
          start: {
            line: 262,
            column: 56
          },
          end: {
            line: 262,
            column: 99
          }
        }],
        line: 262
      },
      "16": {
        loc: {
          start: {
            line: 271,
            column: 14
          },
          end: {
            line: 278,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 271,
            column: 14
          },
          end: {
            line: 278,
            column: 15
          }
        }, {
          start: {
            line: 271,
            column: 14
          },
          end: {
            line: 278,
            column: 15
          }
        }],
        line: 271
      },
      "17": {
        loc: {
          start: {
            line: 293,
            column: 12
          },
          end: {
            line: 300,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 293,
            column: 12
          },
          end: {
            line: 300,
            column: 13
          }
        }, {
          start: {
            line: 293,
            column: 12
          },
          end: {
            line: 300,
            column: 13
          }
        }],
        line: 293
      },
      "18": {
        loc: {
          start: {
            line: 324,
            column: 8
          },
          end: {
            line: 328,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 324,
            column: 8
          },
          end: {
            line: 328,
            column: 9
          }
        }, {
          start: {
            line: 324,
            column: 8
          },
          end: {
            line: 328,
            column: 9
          }
        }],
        line: 324
      },
      "19": {
        loc: {
          start: {
            line: 324,
            column: 12
          },
          end: {
            line: 324,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 324,
            column: 12
          },
          end: {
            line: 324,
            column: 28
          }
        }, {
          start: {
            line: 324,
            column: 32
          },
          end: {
            line: 324,
            column: 58
          }
        }],
        line: 324
      },
      "20": {
        loc: {
          start: {
            line: 336,
            column: 12
          },
          end: {
            line: 341,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 336,
            column: 12
          },
          end: {
            line: 341,
            column: 13
          }
        }, {
          start: {
            line: 336,
            column: 12
          },
          end: {
            line: 341,
            column: 13
          }
        }],
        line: 336
      },
      "21": {
        loc: {
          start: {
            line: 390,
            column: 8
          },
          end: {
            line: 390,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 390,
            column: 8
          },
          end: {
            line: 390,
            column: 42
          }
        }, {
          start: {
            line: 390,
            column: 8
          },
          end: {
            line: 390,
            column: 42
          }
        }],
        line: 390
      },
      "22": {
        loc: {
          start: {
            line: 394,
            column: 8
          },
          end: {
            line: 398,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 394,
            column: 8
          },
          end: {
            line: 398,
            column: 9
          }
        }, {
          start: {
            line: 394,
            column: 8
          },
          end: {
            line: 398,
            column: 9
          }
        }],
        line: 394
      },
      "23": {
        loc: {
          start: {
            line: 394,
            column: 12
          },
          end: {
            line: 394,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 394,
            column: 12
          },
          end: {
            line: 394,
            column: 23
          }
        }, {
          start: {
            line: 394,
            column: 27
          },
          end: {
            line: 394,
            column: 62
          }
        }],
        line: 394
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0]
    },
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2gmp3atjkq.s[0]++;
angular.module("app").controller("mfaController", function ($scope, $rootScope, $state, $uibModal, $translate, $stateParams, $CRUDService, FileUploader, SweetAlert, $deltahttp, $document, $log) {
  cov_2gmp3atjkq.f[0]++;

  var PATH = (cov_2gmp3atjkq.s[1]++, "Projet");

  cov_2gmp3atjkq.s[2]++;
  $scope.loadingMFA = false;

  cov_2gmp3atjkq.s[3]++;
  $scope.isMultifactor = true;
  cov_2gmp3atjkq.s[4]++;
  $scope.isMFAEnabled = false;

  cov_2gmp3atjkq.s[5]++;
  $scope.isAppMultifactor = false;
  cov_2gmp3atjkq.s[6]++;
  $scope.isMailMultifactor = false;

  cov_2gmp3atjkq.s[7]++;
  $scope.choiceMethode = false;
  cov_2gmp3atjkq.s[8]++;
  $scope.isInfoVisible = false;

  cov_2gmp3atjkq.s[9]++;
  $scope.qrCodeDataUri = "";
  cov_2gmp3atjkq.s[10]++;
  $scope.error_mfa = false;
  cov_2gmp3atjkq.s[11]++;
  $scope.mfa = {};
  cov_2gmp3atjkq.s[12]++;
  $scope.userEmail = "";

  cov_2gmp3atjkq.s[13]++;

  $scope.changePasswordView = false;
  cov_2gmp3atjkq.s[14]++;
  $scope.passwords = {
    password: "",
    confirmPassword: ""
  };
  cov_2gmp3atjkq.s[15]++;
  $scope.error_change_password = undefined;

  function init() {
    cov_2gmp3atjkq.f[1]++;
    cov_2gmp3atjkq.s[16]++;

    if (!$rootScope.userConnected) {
      cov_2gmp3atjkq.b[0][0]++;
      cov_2gmp3atjkq.s[17]++;

      $scope.getconnectedUser();
    } else {
      cov_2gmp3atjkq.b[0][1]++;
      cov_2gmp3atjkq.s[18]++;

      $scope.userConnected = $rootScope.userConnected;
      cov_2gmp3atjkq.s[19]++;
      $scope.userEmail = $scope.userConnected.LOGIN;
    }
  }

  cov_2gmp3atjkq.s[20]++;

  $scope.goBack = function () {
    cov_2gmp3atjkq.f[2]++;
    cov_2gmp3atjkq.s[21]++;

    $scope.isMFAEnabled = false;
    cov_2gmp3atjkq.s[22]++;
    $scope.isMultifactor = true;
    cov_2gmp3atjkq.s[23]++;
    $scope.isAppMultifactor = false;
    cov_2gmp3atjkq.s[24]++;
    $scope.isMailMultifactor = false;
    cov_2gmp3atjkq.s[25]++;
    $scope.choiceMethode = false;
    cov_2gmp3atjkq.s[26]++;
    $scope.changePasswordView = false;
  };

  cov_2gmp3atjkq.s[27]++;

  $scope.getconnectedUser = function () {
    cov_2gmp3atjkq.f[3]++;
    cov_2gmp3atjkq.s[28]++;

    $scope.isMFAEnabled = false;
    cov_2gmp3atjkq.s[29]++;
    $CRUDService.getAll(PATH, { get: "user_connected" }, function (data) {
      cov_2gmp3atjkq.f[4]++;
      cov_2gmp3atjkq.s[30]++;

      console.log("user_connected", data);
      cov_2gmp3atjkq.s[31]++;
      $scope.loadingMFA = true;
      cov_2gmp3atjkq.s[32]++;
      $scope.userConnected = data;
      cov_2gmp3atjkq.s[33]++;
      $scope.userEmail = $scope.userConnected.LOGIN;
      cov_2gmp3atjkq.s[34]++;
      $log.log(data);

      cov_2gmp3atjkq.s[35]++;
      if ($scope.userConnected.MFA_ENABLED == 1) {
        cov_2gmp3atjkq.b[1][0]++;
        cov_2gmp3atjkq.s[36]++;


        if ($scope.userConnected.MFA_DISABLED == 1) {
          cov_2gmp3atjkq.b[2][0]++;
          cov_2gmp3atjkq.s[37]++;

          $state.go("index.portfolio");
          cov_2gmp3atjkq.s[38]++;
          return;
        } else {
          cov_2gmp3atjkq.b[2][1]++;
        }

        cov_2gmp3atjkq.s[39]++;
        $scope.isMFAEnabled = true;
        cov_2gmp3atjkq.s[40]++;
        if ((cov_2gmp3atjkq.b[4][0]++, $scope.userConnected.APP_MFA_SECRET) && (cov_2gmp3atjkq.b[4][1]++, $scope.userConnected.APP_MFA_SECRET != "") && (cov_2gmp3atjkq.b[4][2]++, $scope.userConnected.APP_MFA_SECRET != null)) {
          cov_2gmp3atjkq.b[3][0]++;
          cov_2gmp3atjkq.s[41]++;

          $scope.toggle(true, false, true, false);
        } else {
          cov_2gmp3atjkq.b[3][1]++;
        }

        cov_2gmp3atjkq.s[42]++;
        if ($scope.userConnected.EMAIL_MFA_CODE == 1) {
          cov_2gmp3atjkq.b[5][0]++;
          cov_2gmp3atjkq.s[43]++;

          $scope.toggle(true, false, false, true);
          cov_2gmp3atjkq.s[44]++;
          $scope.getEmailCode();
        } else {
          cov_2gmp3atjkq.b[5][1]++;
        }
      } else {
        cov_2gmp3atjkq.b[1][1]++;
      }

      cov_2gmp3atjkq.s[45]++;
      $scope.loadingMFA = false;
    });
  };

  cov_2gmp3atjkq.s[46]++;

  $scope.canChangePassword = function () {
    cov_2gmp3atjkq.f[5]++;
    cov_2gmp3atjkq.s[47]++;

    if ((cov_2gmp3atjkq.b[7][0]++, $scope.userConnected) && (cov_2gmp3atjkq.b[7][1]++, $scope.userConnected.FROM_USER_APPROVISIONNEMENT == 1)) {
      cov_2gmp3atjkq.b[6][0]++;
      cov_2gmp3atjkq.s[48]++;

      return true;
    } else {
      cov_2gmp3atjkq.b[6][1]++;
    }

    cov_2gmp3atjkq.s[49]++;
    return false;
  };

  cov_2gmp3atjkq.s[50]++;

  $scope.showChangePasswordView = function () {
    cov_2gmp3atjkq.f[6]++;
    cov_2gmp3atjkq.s[51]++;

    $scope.changePasswordView = true;

    cov_2gmp3atjkq.s[52]++;

    $scope.isMultifactor = false;
    cov_2gmp3atjkq.s[53]++;
    $scope.isAppMultifactor = false;
    cov_2gmp3atjkq.s[54]++;
    $scope.isMailMultifactor = false;
    cov_2gmp3atjkq.s[55]++;
    $scope.choiceMethode = false;
    cov_2gmp3atjkq.s[56]++;
    $scope.error_mfa = false;
    cov_2gmp3atjkq.s[57]++;
    $scope.error_mfa_length = false;
    cov_2gmp3atjkq.s[58]++;
    $scope.mfa.code = "";

    cov_2gmp3atjkq.s[59]++;
    console.log("showChangePasswordView", {
      changePasswordView: $scope.changePasswordView
    });
  };

  cov_2gmp3atjkq.s[60]++;

  $scope.changePassword = function () {
    cov_2gmp3atjkq.f[7]++;
    cov_2gmp3atjkq.s[61]++;

    $scope.error_change_password = undefined;

    var _ref = (cov_2gmp3atjkq.s[62]++, $scope),
        passwords = _ref.passwords,
        userConnected = _ref.userConnected,
        userEmail = _ref.userEmail;

    cov_2gmp3atjkq.s[63]++;

    if ((cov_2gmp3atjkq.b[9][0]++, !userConnected) || (cov_2gmp3atjkq.b[9][1]++, !userEmail) || (cov_2gmp3atjkq.b[9][2]++, !passwords)) {
      cov_2gmp3atjkq.b[8][0]++;
      cov_2gmp3atjkq.s[64]++;

      $scope.error_change_password = $translate.instant("VALIDATION_MFA.PASSWORDS_EMPTY");
      cov_2gmp3atjkq.s[65]++;
      return;
    } else {
      cov_2gmp3atjkq.b[8][1]++;
    }

    var _ref2 = (cov_2gmp3atjkq.s[66]++, passwords),
        password = _ref2.password,
        confirmPassword = _ref2.confirmPassword;

    cov_2gmp3atjkq.s[67]++;

    if (password !== confirmPassword) {
      cov_2gmp3atjkq.b[10][0]++;
      cov_2gmp3atjkq.s[68]++;

      $scope.error_change_password = $translate.instant("VALIDATION_MFA.PASSWORDS_NOT_SAME");
      cov_2gmp3atjkq.s[69]++;
      return;
    } else {
      cov_2gmp3atjkq.b[10][1]++;
    }

    cov_2gmp3atjkq.s[70]++;
    $CRUDService.save("User", {
      action: "change_password_user_approvisionnement",
      value: {
        password: password,
        confirmPassword: confirmPassword,
        id: userConnected.id,
        email: userEmail
      }
    }, function (response) {
      cov_2gmp3atjkq.f[8]++;
      cov_2gmp3atjkq.s[71]++;

      console.log("response", response);

      cov_2gmp3atjkq.s[72]++;
      if (response == 1) {
        cov_2gmp3atjkq.b[11][0]++;
        cov_2gmp3atjkq.s[73]++;

        $scope.validateMfa();
      } else {
        cov_2gmp3atjkq.b[11][1]++;
      }
    }, function (error) {
      cov_2gmp3atjkq.f[9]++;
      cov_2gmp3atjkq.s[74]++;

      $log.log("change_password_user_approvisionnement error", error);
      cov_2gmp3atjkq.s[75]++;
      $scope.error_change_password = $translate.instant("AUTH_MFA.CHANGE_PASSWORD.ERROR_UNKNOWN");
    });
  };

  cov_2gmp3atjkq.s[76]++;

  $scope.getQrCode = function () {
    cov_2gmp3atjkq.f[10]++;
    cov_2gmp3atjkq.s[77]++;

    $scope.loadingMFA = true;
    cov_2gmp3atjkq.s[78]++;
    $CRUDService.getAll(PATH, { get: "qr_code" }, function (data) {
      cov_2gmp3atjkq.f[11]++;
      cov_2gmp3atjkq.s[79]++;

      $scope.qrCodeDataUri = data.qrCodeDataUri;
      cov_2gmp3atjkq.s[80]++;

      $scope.loadingMFA = false;
    });
  };

  cov_2gmp3atjkq.s[81]++;

  $scope.getEmailCode = function () {
    cov_2gmp3atjkq.f[12]++;
    cov_2gmp3atjkq.s[82]++;

    $scope.loadingMFA = true;
    cov_2gmp3atjkq.s[83]++;
    $CRUDService.getAll(PATH, { get: "send_code" }, function (data) {
      cov_2gmp3atjkq.f[13]++;
      cov_2gmp3atjkq.s[84]++;

      $scope.loadingMFA = false;
      cov_2gmp3atjkq.s[85]++;
      $log.log(data);
    });
  };

  cov_2gmp3atjkq.s[86]++;

  $scope.checkEmailCode = function () {
    cov_2gmp3atjkq.f[14]++;
    cov_2gmp3atjkq.s[87]++;

    $scope.loadingMFA = true;
    cov_2gmp3atjkq.s[88]++;
    $log.log("code email : ", $scope.mfa.code);
    cov_2gmp3atjkq.s[89]++;
    if ((cov_2gmp3atjkq.b[13][0]++, !$scope.mfa.code) || (cov_2gmp3atjkq.b[13][1]++, $scope.mfa.code.length < 6)) {
      cov_2gmp3atjkq.b[12][0]++;
      cov_2gmp3atjkq.s[90]++;

      $scope.error_mfa = false;
      cov_2gmp3atjkq.s[91]++;
      $scope.error_mfa_length = true;
      cov_2gmp3atjkq.s[92]++;
      return;
    } else {
      cov_2gmp3atjkq.b[12][1]++;
    }
    cov_2gmp3atjkq.s[93]++;

    if ((cov_2gmp3atjkq.b[15][0]++, $scope.userConnected.APP_MFA_SECRET != "") && (cov_2gmp3atjkq.b[15][1]++, $scope.userConnected.APP_MFA_SECRET != null)) {
      cov_2gmp3atjkq.b[14][0]++;
      cov_2gmp3atjkq.s[94]++;

      $CRUDService.save(PATH, { action: "another_method", value: $scope.mfa.code }, function (response) {
        cov_2gmp3atjkq.f[15]++;
        cov_2gmp3atjkq.s[95]++;

        $log.log("code saisie : " + $scope.mfa.code);
        cov_2gmp3atjkq.s[96]++;
        $log.log("code valid  : " + response);

        cov_2gmp3atjkq.s[97]++;
        $scope.error_mfa_length = false;
        cov_2gmp3atjkq.s[98]++;
        if (response.valid) {
          cov_2gmp3atjkq.b[16][0]++;
          cov_2gmp3atjkq.s[99]++;

          $scope.error_mfa = false;
          cov_2gmp3atjkq.s[100]++;
          $scope.mfa.code = "";
          cov_2gmp3atjkq.s[101]++;
          $state.go("index.portfolio");
        } else {
          cov_2gmp3atjkq.b[16][1]++;
          cov_2gmp3atjkq.s[102]++;

          $scope.error_mfa = true;
          cov_2gmp3atjkq.s[103]++;
          return;
        }
        cov_2gmp3atjkq.s[104]++;
        $scope.loadingMFA = false;
      });
      cov_2gmp3atjkq.s[105]++;
      return;
    } else {
      cov_2gmp3atjkq.b[14][1]++;
    }

    cov_2gmp3atjkq.s[106]++;
    $CRUDService.save(PATH, { action: "check_code", value: $scope.mfa.code }, function (response) {
      cov_2gmp3atjkq.f[16]++;
      cov_2gmp3atjkq.s[107]++;

      $log.log("code saisie : " + $scope.mfa.code);
      cov_2gmp3atjkq.s[108]++;
      $log.log("code valid  : " + response);

      cov_2gmp3atjkq.s[109]++;
      $scope.error_mfa_length = false;
      cov_2gmp3atjkq.s[110]++;
      if (response.valid) {
        cov_2gmp3atjkq.b[17][0]++;
        cov_2gmp3atjkq.s[111]++;

        $scope.error_mfa = false;
        cov_2gmp3atjkq.s[112]++;
        $scope.mfa.code = "";
        cov_2gmp3atjkq.s[113]++;
        $state.go("index.portfolio");
      } else {
        cov_2gmp3atjkq.b[17][1]++;
        cov_2gmp3atjkq.s[114]++;

        $scope.error_mfa = true;
        cov_2gmp3atjkq.s[115]++;
        return;
      }
      cov_2gmp3atjkq.s[116]++;
      $scope.loadingMFA = false;
    });
  };

  cov_2gmp3atjkq.s[117]++;

  $scope.mfaCheck = function () {
    cov_2gmp3atjkq.f[17]++;
    cov_2gmp3atjkq.s[118]++;

    $scope.loadingMFA = true;
    cov_2gmp3atjkq.s[119]++;
    $log.log($rootScope.connectedUser);
    cov_2gmp3atjkq.s[120]++;
    if ((cov_2gmp3atjkq.b[19][0]++, !$scope.mfa.code) || (cov_2gmp3atjkq.b[19][1]++, $scope.mfa.code.length < 6)) {
      cov_2gmp3atjkq.b[18][0]++;
      cov_2gmp3atjkq.s[121]++;

      $scope.error_mfa = false;
      cov_2gmp3atjkq.s[122]++;
      $scope.error_mfa_length = true;
      cov_2gmp3atjkq.s[123]++;
      return;
    } else {
      cov_2gmp3atjkq.b[18][1]++;
    }

    cov_2gmp3atjkq.s[124]++;
    $CRUDService.save(PATH, { action: "verify_qrcode", value: $scope.mfa.code }, function (response) {
      cov_2gmp3atjkq.f[18]++;
      cov_2gmp3atjkq.s[125]++;

      $log.log("code valid : " + response);
      cov_2gmp3atjkq.s[126]++;
      $scope.error_mfa_length = false;
      cov_2gmp3atjkq.s[127]++;
      if (response.valid) {
        cov_2gmp3atjkq.b[20][0]++;
        cov_2gmp3atjkq.s[128]++;

        $state.go("index.portfolio");
      } else {
        cov_2gmp3atjkq.b[20][1]++;
        cov_2gmp3atjkq.s[129]++;

        $scope.error_mfa = true;
        cov_2gmp3atjkq.s[130]++;
        return;
      }
      cov_2gmp3atjkq.s[131]++;
      $scope.loadingMFA = false;
    });
  };

  cov_2gmp3atjkq.s[132]++;

  $scope.validateMfa = function () {
    cov_2gmp3atjkq.f[19]++;
    cov_2gmp3atjkq.s[133]++;

    $state.go("index.portfolio");
  };

  cov_2gmp3atjkq.s[134]++;

  $scope.toggle = function (a, b, c, d) {
    cov_2gmp3atjkq.f[20]++;
    cov_2gmp3atjkq.s[135]++;

    $scope.isMultifactor = a;
    cov_2gmp3atjkq.s[136]++;
    $scope.choiceMethode = b;
    cov_2gmp3atjkq.s[137]++;
    $scope.isAppMultifactor = c;
    cov_2gmp3atjkq.s[138]++;
    $scope.isMailMultifactor = d;
  };

  cov_2gmp3atjkq.s[139]++;

  $scope.toggleInfo = function (event) {
    cov_2gmp3atjkq.f[21]++;
    cov_2gmp3atjkq.s[140]++;

    $scope.isInfoVisible = !$scope.isInfoVisible;
    cov_2gmp3atjkq.s[141]++;
    event.stopPropagation();
  };

  cov_2gmp3atjkq.s[142]++;

  var clickHandler = function clickHandler(event) {
    cov_2gmp3atjkq.f[22]++;
    cov_2gmp3atjkq.s[143]++;

    if (!$scope.isInfoVisible) {
        cov_2gmp3atjkq.b[21][0]++;
        cov_2gmp3atjkq.s[144]++;
        return;
      } else {
      cov_2gmp3atjkq.b[21][1]++;
    }var infoElement = (cov_2gmp3atjkq.s[145]++, document.querySelector('div[ng-if="isInfoVisible"]'));
    cov_2gmp3atjkq.s[146]++;
    if ((cov_2gmp3atjkq.b[23][0]++, infoElement) && (cov_2gmp3atjkq.b[23][1]++, !infoElement.contains(event.target))) {
      cov_2gmp3atjkq.b[22][0]++;
      cov_2gmp3atjkq.s[147]++;

      $scope.$apply(function () {
        cov_2gmp3atjkq.f[23]++;
        cov_2gmp3atjkq.s[148]++;

        $scope.isInfoVisible = false;
      });
    } else {
      cov_2gmp3atjkq.b[22][1]++;
    }
  };

  cov_2gmp3atjkq.s[149]++;
  $document.on("click", clickHandler);

  cov_2gmp3atjkq.s[150]++;

  $scope.$on("$destroy", function () {
    cov_2gmp3atjkq.f[24]++;
    cov_2gmp3atjkq.s[151]++;

    $document.off("click", clickHandler);
  });

  cov_2gmp3atjkq.s[152]++;

  init();
});